import React from 'react'
import { Row, Col, Spacer, Image } from '@cleartrip/bento'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { isEmpty } from 'utils/browserHelper'
import { getPopularDestinationUrl } from 'utils/uiHelper'
import { sendClevertapUIActionEventWithAdditionalData } from 'utils/flights/itinerary/logPageLoadEvents'

function TopDestinations({ resultsData }) {
    const { destinations = [] } = resultsData || {}
    if (destinations.lenght > 0) {
        destinations.pop()
    }
    const dalayerGA = name => {
        dataLayerGA({ clicked_option_name: name, section: 'General' }, 'popular_destinations_click')
    }

    const hotelsListsBlock =
        !isEmpty(resultsData) &&
        !isEmpty(resultsData.destinations) &&
        destinations.map((destination, idx) => (
            <div key={idx}>
                <a
                    href={getPopularDestinationUrl(destination.page_url)}
                    onClick={() => {
                        dalayerGA(destination.name)
                        sendClevertapUIActionEventWithAdditionalData({
                            actionName: 'popular_destination',
                            additionalData: {
                                slot: idx + 1,
                                pageName: 'homepage'
                            }
                        })
                    }}
                    className="td-none"
                    target="_blank"
                >
                    <div className="br-8 o-hidden p-relative">
                        <Image height={235} width={184} src={destination.image_url} />
                        <div className="imgGrad">
                            <p className="fs-5 fw-600 c-neutral-0 px-4 p-absolute" style={{ top: '65%' }}>
                                {destination.name}
                            </p>
                            <p className="c-neutral-0 fw-500 fs-3 pt-1 px-4 p-absolute" style={{ top: '77%' }}>
                                {destination.property_count} Properties
                            </p>
                        </div>
                    </div>

                    <Spacer className="pt-2" />
                </a>
            </div>
        ))
    return <div className="flex flex-middle flex-between">{hotelsListsBlock}</div>
}

export default TopDestinations
